import React from 'react'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import fetchJSON from 'lib/fetchJSON'
import { CTA } from 'common/styleguide/CTA'

export const REPLACE_ELEVATION_MODAL = 'REPLACE_ELEVATION_MODAL'

export class ReplaceElevationModal extends React.PureComponent {
  state = {
    stage: 'getConfirmation' // getConfirmation -> pending -> success
  }

  replaceElevation = () => {
    const { troute, objectType } = this.props
    this.setState({ stage: 'pending' })
    // not something that makes sense to do with a Redux-based api
    fetchJSON(`/${objectType}s/${troute.id}/replace_elevations`, null, { method: 'POST' })
      .then(() => this.setState({ stage: 'success' }))
  }

  render () {
    const { objectType, onRequestClose } = this.props
    const { stage } = this.state
    if (stage === 'success') {
      return <ReplaceElevationSuccessDialog onRequestClose={onRequestClose} objectType={objectType} />
    }
    return (
      <ConfirmationDialog
        title='Replace Elevation Data?'
        confirmText='Replace Elevations'
        onConfirm={this.replaceElevation}
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}>
        <p>
          Replace elevations? This will discard your previous elevation data with
          elevation data from our map data, and cannot be undone.
        </p>
      </ConfirmationDialog>
    )
  }
}

export const ReplaceElevationSuccessDialog = ({ onRequestClose, objectType }) => (
  <ModalOverlay
    title='Refetch in progress'
    maxWidth='500px'
    onRequestClose={onRequestClose}>
    <p>
      We've started an elevation refetch for your {objectType}.
      Refresh the page in a few minutes to see the result.
    </p>
    <CTA onClick={onRequestClose}>Close</CTA>
  </ModalOverlay>
)
